/*
* Project: LegalPlace assistant
* File: src\components\misc\date.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  initOutputVariable, editVariable, initOutputOption, editOption,
} from '../../redux/actions/output';

// importing additional componentns
import MaskedInput from './masked_input';
import LpPopupPreview from '../popup_preview';
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';
import lpApp from '../../app/lp_app';
// dateformat
class _DatePicker extends Component {
  constructor(props) {
    super(props);
    this.onValueChanged = this.onValueChanged.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentWillMount() {
    if (!this.props.exists) {
      this.props.initializeOutput(this.props.id, this.props.ovc, '');
    }
  }

  onFocus() {
    this.props.updateContext();
  }

  onBlur() {
    this.props.unUpdateContext();
  }

  onValueChanged(val) {
    // Fri Nov 17 2017 00:00:00 GMT+0100 (CET)
    // let formatted_date = new Intl.DateTimeFormat().format(val);
    // console.log( val);
    this.props.editOutput(this.props.id, val);
  }

  render() {
    return (
      <div className="form-group">

        <label htmlFor={`date_${this.props.lpKey}`}>{this.props.label}</label>
        {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
        <div className="fc-container">
          <MaskedInput
            type="text"
            className="form-control form-calendar"
            value={this.props.value}
            onChange={ev => this.onValueChanged(ev.target.value)}
            mask="!!/!!/!!!!"
            placeholder="JJ/MM/AAAA"
            onBlur={this.onBlur}
            onFocus={this.onFocus}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // test if exists
  let exists = false;
  let existantKey = '';
  let value = '';
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;

  if (ownProps.ovc === 'o') {
    const opt = lpGetOptionById(realId);
    if (typeof opt !== 'undefined') {
      exists = true;
      existantKey = opt.key;
      ({ value } = opt);
    }
  }
  if (ownProps.ovc === 'v') {
    const opt = lpGetVariableById(realId);
    if (typeof opt !== 'undefined') {
      exists = true;
      existantKey = opt.key;
      ({ value } = opt);
    }
  }

  return {
    sectionId: state.contract.currentSection,
    exists,
    existantKey,
    value,

  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  // this case, parent = key
  initializeOutput: (id, genre, value = '') => {
    let cId;
    if (ownProps.isDuplicate) {
      cId = `${ownProps.id}_${ownProps.copy}`;
    } else {
      cId = ownProps.id;
    }
    if (genre === 'o') dispatch(initOutputOption(cId, ownProps.lpKey, value));
    else if (genre === 'v') dispatch(initOutputVariable(cId, ownProps.lpKey, value));
  },
  editOutput: (id, val) => {
    let cId;
    if (ownProps.isDuplicate) {
      cId = `${ownProps.id}_${ownProps.copy}`;
    } else cId = ownProps.id;
    if (ownProps.ovc === 'o') {
      dispatch(editOption(cId, val));
    } else {
      dispatch(editVariable(cId, val));
    }
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },
});
_DatePicker.childContextTypes = {
  muiTheme: React.PropTypes.object.isRequired,
};
const LpDatePicker = connect(mapStateToProps, mapDispatchToProps)(_DatePicker);

export default LpDatePicker;



// WEBPACK FOOTER //
// ./src/components/misc/date.js